window.addEventListener('load', function() {
    AOS.init();
})